import { useApi } from './useApi';
import { apiService } from '../services/api';

interface NavigationLink {
  label: string;
  url: string;
}

interface LegalLink {
  label: string;
  url: string;
}

interface StrapiImageData {
  id: number;
  url: string;
  alternativeText?: string;
  width: number;
  height: number;
  formats?: {
    thumbnail?: { url: string; width: number; height: number; };
    small?: { url: string; width: number; height: number; };
    medium?: { url: string; width: number; height: number; };
    large?: { url: string; width: number; height: number; };
  };
}

interface FooterSectionData {
  id: number;
  documentId: string;
  ctaTitle?: string;
  ctaDescription?: string;
  ctaButtonText?: string;
  ctaButtonUrl?: string;
  logo?: StrapiImageData;
  navigationTitle?: string;
  navigationLinks?: NavigationLink[];
  contactTitle?: string;
  contactAddress?: string;
  contactPhone?: string;
  contactHours?: string;
  googleMapsUrl?: string;
  copyrightText?: string;
  madeByText?: string;
  madeByLinkText?: string;
  madeByLinkUrl?: string;
  legalLinks?: LegalLink[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useFooterSection() {
  return useApi<FooterSectionData>(apiService.getFooterSection);
}